import axios from 'axios';

const CancelToken = axios.CancelToken;
const axiosSource = CancelToken.source();
axios.defaults.cancelToken = axiosSource.token;

export { axiosSource };
